// Activity-specific utility functions
import { logError } from '@/scripts/utils/errorHandler'

export function getUnlockString(day: number, currentDay: number): string {
  const dateDiff: number = day - currentDay
  if (dateDiff <= 0) {
    logError('getUnlockString: day should be greater than currentDay', { day, currentDay })
    return ''
  }
  if (!day) return ''

  const dayLabel = dateDiff === 1 ? 'den' : dateDiff < 5 ? 'dny' : 'dní'

  return `Počkej ${dateDiff} ${dayLabel}`
}

export function getIframeTemplate(url: string): string {
  const urlWithParams = url
  return `<iframe class="iframe" src="${urlWithParams}" width="100%" height="100%" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" allow="autoplay" />`
}
